<mat-card
    class="grid-card-v2 box-shadow-md swiper-slide-body mb-2"
    id="test"
    [ngClass]="{
        'large-content': environmentVariables?.PRODUCT_CARD_STYLE == 'large',
        'english-direction': lang == 'en',
        'arabic-direction': lang == 'ar'
    }"
>
    <div
        class="img-brand"
        [ngClass]="lang == 'en' ? 'right-0' : 'left-0'"
        *ngIf="product?.brand && environmentVariables?.SHOW_BRAND_ON_PRODUCT"
    >
        <img  loading="lazy"  [src]="product?.brand.image"    [alt]="product?.brand.image" />
    </div>
    <div
        class="mat-upper"
        [ngClass]="
            environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                ? 'mat-upper-bigImg'
                : ''
        "
    >
        <div class="chip-container pointer-event-none d-flex flex-column">
            <mat-chip
                *ngIf="
                    product?.discount_price !== null &&
                    !product?.promotion &&
                    product.discount_price != product.price
                "
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{
                    ((product?.price - product?.discount_price) /
                        product?.price) *
                        100 | number: "1.0-0"
                }}
                % 
                <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                  {{ "productDetails.off" | translate }}
                </span>
               
            </mat-chip>

            <mat-chip
                *ngIf="product?.discount_price !== null && product?.promotion"
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                <ng-container *ngIf="lang == 'en'">
                    {{ product?.promotion_en }} OR
                    {{
                        ((product?.price - product?.discount_price) /
                            product?.price) *
                            100 | number: "1.0-0"
                    }}
                    %
                    <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                        OFF
                    </span>
                </ng-container>
                <ng-container *ngIf="lang == 'ar'">
                    {{ product?.promotion_ar }} أو خصم
                    {{
                        ((product?.price - product?.discount_price) /
                            product?.price) *
                            100 | number: "1.2-2"
                    }}
                    %
                </ng-container>
            </mat-chip>

            <mat-chip
                *ngIf="product?.preorder"
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{ "productDetails.preorder" | translate }}
            </mat-chip>

            <mat-chip
                *ngIf="product?.available_soon"
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{ "productDetails.availableSoon" | translate }}
            </mat-chip>

            <mat-chip
                *ngIf="product?.type === 2"
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{ "productDetails.bundle" | translate }}
            </mat-chip>

            <mat-chip
                *ngIf="
                    product?.promos?.length &&
                    product?.promos[0]?.show_in_product != 0
                "
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{ product?.promos[0]?.name }}
            </mat-chip>
            <mat-chip
                *ngIf="
                    product?.commission_amount &&
                    user?.is_affiliate &&
                    product?.commission_amount != 0
                "
                class="chip-commission-amount my-1"
                tabindex="-1"
            >
                {{ "orders.commission" | translate }} :
                {{ product?.commission_amount | number: "1.2-2" }}
                {{
                    lang == "en"
                        ? environmentVariables?.CURRENCY_CODE_EN
                        : environmentVariables?.CURRENCY_CODE_AR
                }}
            </mat-chip>

            <mat-chip
                *ngIf="product?.promotion && !product?.direct_discount"
                class="chip-item my-1 pointer-event-none"
                tabindex="-1"
            >
                {{
                    lang == "en" ? product?.promotion_en : product?.promotion_ar
                }}
            </mat-chip>
        </div>
        <!-- [queryParams]="{
          variant:
              environmentVariables?.PRODUCT_TYPE == 'main'
                  ? product?.product_variants[0]?.id
                  : product?.id
      }" -->
        <a
            [routerLink]="environmentVariables?.PRODUCT_TYPE == 'main' ? ['/' + lang + '/' + product?.product_variants[0]?.slug] : ['/' + lang + '/' + product?.slug]"
       
            class="p-link pointer no-outline"
        >
            <img  loading="lazy" 
                [src]="product?.image"
                   [alt]="product?.name"
                mat-card-image
                default="./assets/images/placeholder200.jpg"
                onError="this.src='./assets/images/placeholder200.jpg';"
                class="my-0 mx-auto no-outline w-100 image-default"
                [ngClass]="
                    environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                        ? 'bigImg'
                        : ''
                "
            />

            <img  loading="lazy" 
                [src]="product?.images[0]?.url || product?.image"
                   [alt]="product?.images[0]?.url || product?.image"
                mat-card-image
                default="./assets/images/placeholder200.jpg"
                onError="this.src='./assets/images/placeholder200.jpg';"
                class="my-0 mx-auto no-outline w-100 image-hover"
                [ngClass]="
                    environmentVariables?.PRODUCT_CARD_STYLE == 'medium'
                        ? 'bigImg'
                        : ''
                "
            />
        </a>
    </div>
    <mat-card-content class="product-content relative mb-0 mt-2">
        <div class="d-flex flex-column justify-space-between content-data">
            <p
                class="category-item"
                *ngIf="environmentVariables?.SHOW_CATEGORY_ON_PRODUCT_CARD"
            >
                {{
                    lang === "en"
                        ? product.category?.name
                        : product.category?.name_ar
                }}
                <ng-container *ngIf="product?.optional_category"
                    >,
                    {{
                        lang === "en"
                            ? product?.optional_category?.name
                            : product?.optional_category?.name_ar
                    }}</ng-container
                >
            </p>
            <div *ngIf="environmentVariables?.PRODUCT_TYPE != 'main'">
                <p
                    class="product-title fade mb-0 pointer"
                    [class.direction-ar]="lang == 'ar'"
                >
                <!-- [queryParams]="{
                  variant:
                      environmentVariables?.PRODUCT_TYPE == 'main'
                          ? product?.product_variants[0]?.id
                          : product?.id
              }" -->
                    <a
                    [routerLink]=" environmentVariables?.PRODUCT_TYPE == 'main' ? ['/' + lang + '/' + product?.product_variants[0]?.slug] : ['/' + lang + '/' + product?.slug]"
                    
                        class="no-outline"
                        >{{
                            lang == "en" ? product?.name_en : product?.name_ar
                        }}
                    </a>
                </p>
            </div>

            <div *ngIf="environmentVariables?.PRODUCT_TYPE == 'main'">
                <h5
                    class="product-title fade mb-0 pointer"
                    [class.direction-ar]="lang == 'ar'"
                >
                <!-- [queryParams]="{
                  variant:
                      environmentVariables?.PRODUCT_TYPE == 'main'
                          ? product?.product_variants[0]?.id
                          : product?.id
              }" -->
                    <a
                    [routerLink]="environmentVariables?.PRODUCT_TYPE == 'main' ? ['/' + lang + '/' + product?.product_variants[0]?.slug] : ['/' + lang + '/' + product?.slug]"
                
                        class="no-outline"
                        >{{
                            lang == "en" ? product?.name_en : product?.name_ar
                        }}
                    </a>
                </h5>
            </div>

            <div
                class="d-flex flex-column align-items-start"
                [dir]="lang === 'en' ? 'ltr' : 'rtl'"
            >
                <div
                    class="my-2"
                    class="d-flex align-items-start"
                    [ngClass]="{
                        'flex-row gap-5 font-15':
                            environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE,
                        'flex-column':
                            !environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE
                    }"
                >
                    <del
                        *ngIf="
                            product?.discount_price &&
                            (product?.in_stock ||
                                environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
                            environmentVariables?.GUEST_CAN_VIEW_PRICES
                        "
                        [ngClass]="lang == 'en' ? 'mr-1' : 'price-ar ml-1'"
                    >
                        {{ product?.price }}
                        {{
                            lang == "en"
                                ? environmentVariables?.CURRENCY_CODE_EN
                                : environmentVariables?.CURRENCY_CODE_AR
                        }}
                    </del>
                    <div
                        *ngIf="
                            product?.in_stock ||
                            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE
                        "
                        [ngClass]="lang == 'en' ? '' : 'price-ar'"
                        style="font-family: Roboto, sans-serif !important"
                        class="color-brand payment-with-discount-container d-flex"
                    >
                        <ng-container
                            *ngIf="
                                product?.price &&
                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                            "
                        >
                            {{
                                product?.discount_price !== null
                                    ? product?.discount_price
                                    : product?.price
                            }}
                            {{
                                lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                            }}
                            <div
                                class="discount-method-information"
                                *ngIf="
                                    product?.payment_methods_discount_name_en
                                "
                            >
                                <p>i</p>
                                <div class="hover-info">
                                    {{
                                        lang == "en"
                                            ? product?.payment_methods_discount_name_en
                                            : product?.payment_methods_discount_name_ar
                                    }}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <span [ngClass]="lang == 'en' ? '' : 'price-ar'" class="up-to">
                <ng-container
                    *ngIf="
                        product?.variant_max_price &&
                        ((product?.discount_price &&
                            product?.variant_max_price >
                                product?.discount_price) ||
                            (!product?.discount_price &&
                                product?.variant_max_price > product?.price))
                    "
                >
                    {{ lang == "en" ? " up to " : " حتى "
                    }}{{ product?.variant_max_price }}
                    {{
                        lang == "en"
                            ? environmentVariables.CURRENCY_CODE_EN
                            : environmentVariables.CURRENCY_CODE_AR
                    }}
                </ng-container>
            </span>

            <ng-container>
                <span
                    *ngIf="
                        !product?.in_stock &&
                        product?.price &&
                        product?.stock == 0 &&
                        environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE &&
                        environmentVariables?.GUEST_CAN_VIEW_PRICES
                    "
                    class="out-of-stock text-center"
                >
                    {{ product?.price | number: "1.0" }}
                    {{
                        lang == "en"
                            ? environmentVariables?.CURRENCY_CODE_EN
                            : environmentVariables?.CURRENCY_CODE_AR
                    }}</span
                >
            </ng-container>
            <ng-container>
                <span
                    *ngIf="!product?.in_stock && !product?.available_soon"
                    class="out-of-stock text-center"
                >
                    {{ "home_Page.outOfStouck" | translate }}</span
                >
            </ng-container>
            <ng-container
                *ngIf="
                    environmentVariables?.PRODUCT_TYPE == 'main' &&
                    environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS
                "
            >
                <div
                    class="image-gallary-container"
                    *ngIf="variantValues && variantValues.length > 0"
                >
                    <div
                        class="gallery-image"
                        *ngFor="
                            let value of variantValues.slice(0, variantsLimit)
                        "
                        (mouseenter)="
                            variantOptions?.type == '3' ||
                            variantOptions?.type == '4'
                                ? setChossenData(value.id)
                                : ''
                        "
                        [class.text-box]="variantOptions?.type == '1'"
                        [class.color-box]="variantOptions?.type == '2'"
                        [class.image-box]="
                            variantOptions?.type == '3' ||
                            variantOptions?.type == '4'
                        "
                        [style.background-color]="
                            variantOptions?.type == '2'
                                ? value?.color_code
                                : 'transparent'
                        "
                        [style.border]="
                            variantOptions?.type == '2' ? '1px solid #000' : ''
                        "
                    >
                        <span
                            *ngIf="variantOptions?.type == '1'"
                            style="font-size: 12px; line-height: 1"
                            >{{ value?.name }}</span
                        >
                        <span *ngIf="variantOptions?.type == '2'"></span>
                        <img  loading="lazy" 
                            *ngIf="
                                variantOptions?.type == '3' ||
                                variantOptions?.type == '4' ||
                                value?.image
                            "
                            [src]="value.image"
                               [alt]="value.image"
                            onError="this.src='./assets/images/placeholder200.jpg';"
                            default="./assets/images/placeholder200.jpg"
                        />
                    </div>
                    <!-- [queryParams]="{ variant: product?.id }" -->

                    <a
                        [routerLink]="[
                            '/' + lang + '/' + product?.slug
                        ]"
                        *ngIf="variantValues.length > variantsLimit"
                        class="gallery-image plus-variants"
                    >
                        +{{ variantValues.length - variantsLimit }}
                    </a>
                </div>
            </ng-container>
        </div>
    </mat-card-content>

    <mat-card-footer style="margin-top: 0; height: 65px; padding-top: 16px">
        <div
            [ngClass]="lang == 'ar' ? 'parent-arabic-position' : ''"
            fxLayoutAlign="space-between center"
        >
            <div class="card-actions">
                <div
                    class="favorite-icon-container d-flex align-items-end flex-column"
                    [ngClass]="
                        environmentVariables?.FAVORITE_ICON_POSITION == 'top'
                            ? 'favorite-top-location'
                            : ''
                    "
                >
                    <mat-icon
                        *ngIf="!product?.favouriteLoading"
                        (click)="
                            addToFavouriteList(
                                environmentVariables?.PRODUCT_TYPE == 'main'
                                    ? product?.product_variants[0]
                                    : product,
                                environmentVariables?.PRODUCT_TYPE
                            )
                        "
                        [ngClass]="
                            product?.is_favourite ||
                            product?.product_variants[0]?.is_favourite
                                ? 'wishlist-active'
                                : ''
                        "
                        class="material-icons d-flex favorite pointer"
                    >
                        favorite
                    </mat-icon>
                    <div
                        class="loader-container"
                        *ngIf="product?.favouriteLoading"
                    >
                        <app-loading></app-loading>
                    </div>
                </div>
                <button
                    *ngIf="!environmentVariables?.DISABLE_COMPARE"
                    (click)="
                        addToCompareList(
                            environmentVariables?.PRODUCT_TYPE == 'main'
                                ? product?.product_variants[0]
                                : product
                        )
                    "
                    [ngClass]="lang == 'ar' ? 'arabic-position' : ''"
                    class="compare-icon-container"
                    title="Compare"
                    [disabled]="product?.toggleCompareLoading"
                    [style.cursor]="
                        product?.toggleCompareLoading
                            ? 'not-allowed'
                            : 'pointer'
                    "
                >
                    <mat-icon
                        [ngClass]="
                            product?.is_compare ||
                            product?.product_variants[0]?.is_compare
                                ? 'compare-active'
                                : ''
                        "
                        class="material-icons"
                        *ngIf="!product?.toggleCompareLoading"
                    >
                        compare
                    </mat-icon>
                    <div
                        class="loader-container"
                        *ngIf="product?.toggleCompareLoading"
                    >
                        <app-loading></app-loading>
                    </div>
                </button>
            </div>

            <app-control-add-to-cart
                *ngIf="product"
                [product]="product"
                [styleCard]="true"
                [styleCardHomeAr]="true"
                [redirectToProduct]="redirectToProduct"
            >
            </app-control-add-to-cart>
        </div>
    </mat-card-footer>
</mat-card>
